import axios from 'axios';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {LocalStorageKey} from "@shared/config/local-storage-key";
import {BASE_OWNER_URL} from "@shared/config/base-url";
import {CommonDto} from "@shared/types/common-dto";
import {LOGIN_OK} from "@shared/config/constants";
import {SignInType} from "@entities/auth/types/login-types";
import { extractApiError } from "@shared/lib/api/extract-api-error";


const defaultErrorMessage = 'An unexpected error occurred.';

export const useLoginApi = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const loginApi = async (id: string, pw: string) => {
        setLoading(true);
        setError(null);

        try {
            const formData = new FormData();
            formData.append('id', id);
            formData.append('password', pw);
            const response = await axios.post(`${BASE_OWNER_URL}/api/v3/login`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    //'X-Request-Source': 'web', // 헤더 추가
                },
                withCredentials: true, // CORS 요청 시 쿠키 및 인증 헤더를 포함
            });
            const apiResponse: CommonDto<SignInType> = response.data;
            const accessToken = apiResponse.data?.accessToken;
            const refreshToken = apiResponse.data?.refreshToken;
            if (apiResponse.success && accessToken && refreshToken) {
                localStorage.setItem(LocalStorageKey.AUTHORIZATION, accessToken);
                localStorage.setItem(LocalStorageKey.RE_AUTHORIZATION, refreshToken);
                localStorage.setItem(LocalStorageKey.LOGIN_STATE, LOGIN_OK);

                navigate('/home/user');
            } else {
                const errorMessage =
                    apiResponse.error?.message || defaultErrorMessage;
                setError(errorMessage);
            }
        } catch (e) {
            // 로그인 화면 — 네트워크/타임아웃 시 raw axios 메시지("Network Error" 등) 대신 친화 문구.
            const errorMessage = extractApiError(e, defaultErrorMessage, { preferFallback: true });
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return {loginApi, loading, error};
};
